export const userTypes = [
  {
    label: 'Registered User',
    value: 'registered_user',
  },
  {
    label: 'Visitor',
    value: 'visitor',
  },
]